<script setup lang="ts">
  import { IconImage } from '@/shared/ui';
  import PrinterIcon from '@/shared/assets/icons/PrinterIcon.svg';
  import {
    buildModalPrintDocument,
    buildPrintBodyHtml,
    buildPrintHeaderHtml,
    collectPrintStyles,
    ensurePrintSvgViewBox,
    repeatPrintHeaderAcrossPages,
    waitForPrintAssets,
    waitForPrintLayoutSettle,
    syncFormFieldValues,
  } from '@/shared/lib/print';

  const props = withDefaults(
    defineProps<{
      documentInfo: {
        documentPrefix?: string;
        revision?: string;
        documentNumber?: string;
      };
      pillLabel?: string;
      compact?: boolean;
      title?: string;
      hasDocumentPrefix?: boolean;
      printStyles?: string;
      resolveLogoSrc?: () => Promise<string>;
    }>(),
    {
      pillLabel: 'Prefixo',
      compact: false,
      title: undefined,
      hasDocumentPrefix: true,
      printStyles: '',
      resolveLogoSrc: undefined,
    }
  );

  const handlePrint = async () => {
    const printContent = document.getElementById('modal-content');
    if (!printContent) return;

    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    syncFormFieldValues(printContent);

    const [headerElement, ...bodyElements] = Array.from(printContent.children);
    const headerHtml = buildPrintHeaderHtml(headerElement, await props.resolveLogoSrc?.());
    const bodyHtml = buildPrintBodyHtml(bodyElements);

    printWindow.document.write(
      buildModalPrintDocument({
        title: props.documentInfo.documentNumber || 'Documento',
        headerHtml,
        bodyHtml,
        styles: `${collectPrintStyles()}\n${props.printStyles}`,
        compact: props.compact,
      })
    );
    printWindow.document.close();
    if (props.compact) {
      ensurePrintSvgViewBox(printWindow);
    }
    await waitForPrintAssets(printWindow);
    await waitForPrintLayoutSettle(printWindow);
    repeatPrintHeaderAcrossPages(printWindow);
    printWindow.print();
  };
</script>

<template>
  <div class="flex justify-end items-center mb-6 gap-2.5">
    <div v-if="hasDocumentPrefix" class="bg-gray-200 px-2 py-0.5 rounded-full">
      <span class="text-sm font-medium"
        >{{ pillLabel }}: {{ documentInfo.documentPrefix ?? '—' }}</span
      >
    </div>
    <button
      class="bg-[var(--theme-secondary)] cursor-pointer text-white px-3.25 py-3 rounded flex items-center gap-2 transition-colors print:hidden"
      @click="handlePrint"
    >
      <IconImage name="PrinterIcon" :src="PrinterIcon" alt="Imprimir" />
    </button>
  </div>
</template>
